var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-app",class:{
  'has-tabbar': _vm.hasTabbar
},attrs:{"id":"kApp"}},[_c('k-navbar'),_c('router-view'),(_vm.hasTabbar)?_c('k-tabbar',{attrs:{"current":_vm.idxTabbar}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }